import React from 'react';
import SelectControl from './SelectControl';
import Select from 'react-select';
import i18n from '../../../../src/i18n/translate';
import { DROPDOWN_SEARCH_MINIMUM } from '../../../constants';
import { rendererProps } from '../ControlHelpers/SelectUtils.js';

/** SelectCreatableControl provides a select control that allows adding options to the list while also implementing
 * the standard functions that ReactiFi controls must include, such as form validation, by extending the default SelectControl **/
export default class SelectCreatableControl extends SelectControl {
  render(){
    let translationProps = {
      searchPromptText: i18n.t("Type to search"),
      noResultsText: i18n.t("No results found"),
      loadingPlaceholder: i18n.t("Loading..."),
      clearAllText: i18n.t("Clear all"),
      clearValueText: i18n.t("Clear value")
    }

    //extract extra props that Select.Creatable won't know what do with
    let { setError, name, ...props } = this.props;  // eslint-disable-line no-unused-vars
    name = this.props.multi ? name + '[]' : name;
    return (
      <Select.Creatable
        {...props}
        onBlur={this.onBlur}
        ref={(select) => (this.select = select)}
        onFocus={this.onFocus}
        searchable={this.props.options && !this.props.options.length < DROPDOWN_SEARCH_MINIMUM}
        {...translationProps}
        {...rendererProps(this.props.multi)}
        value={this.state.value}
        onChange={this.onChange}
        name={name}
        scrollMenuIntoView={false}
        placeholder={this.props.placeholderText}
      />
    );
  }
}
